export default {
    GET_LIST_CATEGORY: '[CATEGORY] GET_LIST_CATEGORY',
    GET_LIST_CATEGORY_RESULT: '[CATEGORY] GET_LIST_CATEGORY_RESULT',

    TYPE_GET_CATEGORY: 'get_category'
}



// WEBPACK FOOTER //
// ./src/view/constant/CategoryConstant.js